//@flow
import React from 'react';
import ZopimLoader from '../../Chat/components/ZopimLoader.react';

type Props = {
  magicLinkEmail:string,
  showSignIn:() => void,
};

export default function MagicLinkSent(props:Props) {
  return (
    <div className="reset-container">
      <h2 className="reset-header">Email sent</h2>
      <div className="reset-subheader">
        A sign in link was emailed to <span className="bold">{props.magicLinkEmail}</span>.  The link will automatically sign you into NatureBox, no password necessary. It expires in 24 hours, so use it soon!
      </div>
      <div className="text-4">
        Not sure if it&apos;s the correct email?&nbsp;
        <ZopimLoader onlineText="Contact us" offlineText="Contact us" />
      </div>
      <button className="back-to-signin" onClick={props.showSignIn}>Back to sign in</button>
    </div>
  );
}
